const permissions = {
  console: 'CM001'
};

export default permissions;
